import React, { useEffect } from "react";
import { Header } from "../components/Common/Header";
import { BlogCard2 } from "../components/Blogs/BlogCard2";
import workshops from "../data/Workshops/Workshops.json";

import BgImage from "../assets/images/Headers/Workshops.webp";

export const Workshops = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header
        image={BgImage}
        title="Workshops"
      />

      <div
        style={{
          padding: "50px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "50px",
          }}
        >
          {workshops.map((blog, index) => (
            <BlogCard2
              id={blog.id}
              key={index}
              image={blog.image}
              title={blog.title}
              readtime={blog.readtime}
              category={blog.category}
              caption={
                blog.description.length > 150
                  ? `${blog.description.slice(0, 150)}...`
                  : blog.description
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};